webpackJsonp([23],{

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    snackbar: Boolean,
    dialog: Boolean,
    lat: Number,
    lng: Number
  },
  methods: {
    onClick: function onClick() {
      this.$emit('update:snackbar', false);
      this.$emit('update:dialog', true);
    }
  }
});

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(777),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 777:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marker-window"
  }, [_c('v-btn', {
    staticClass: "window-input",
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.lat) + "," + _vm._s(_vm.lng))])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.b5538d9a028a62449aae.js